export const GET_CHIP_STATUS = "get-chip-status";
export const MY_CHIP_DATA = "my-chip-data";
export const OPERATE_CHIP = "operate-chip";
